export default "__VITE_ASSET__B2xL64xy__"